import { css } from 'styled-components'
import { rgba } from 'polished'

import { black } from './colors'

// Vertical padding
export const verticalPadding = padding => css`
  padding-top: ${padding};
  padding-bottom: ${padding};
`

// Square
export const square = size => css`
  width: ${size};
  height: ${size};
`

// Shadow
export const boxShadow = `box-shadow: 0px 4px 104px ${rgba(black, 0.1)};`

// Cover
export function cover(position) {
  return `
    position: ${position};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  `
}
